import { NewsList } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { GetNewsListResponse } from "../schema/GetNewsListResponse";
import { mapNewsList } from "../../mappers/news/newsListMapped";

export const getNewsListBySearch = async (searchTitle: string, p0?: { page: string; }): Promise<NewsList> => {
    const client = ApiClient.getInstance()
    const pageParam = p0?.page ? `?page=${p0.page}` : '';

    const response = await client.get<GetNewsListResponse>(`news/by-search-bar?title=${searchTitle}${pageParam}`)

    const mappedResponse = mapNewsList(response.data)

    return mappedResponse;
}